export const triggerClickOnCanvas = (event) => {
  const canvasElem = document.querySelector('canvas')

  canvasElem &&
    canvasElem.dispatchEvent(
      new MouseEvent('mousedown', {
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: event.clientX,
        clientY: event.clientY,
      }),
    )
}
